import React from 'react';
import { ShieldCheckIcon, PlusIcon } from 'lucide-react';
interface GuardrailsViewProps {
  userPlan: string;
}
export function GuardrailsView({
  userPlan
}: GuardrailsViewProps) {
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-319">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-320">
        <div data-id="element-321">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-322">Guardrails</h2>
          <p className="text-sm text-gray-600 mt-1" data-id="element-323">
            Configure safety measures and quality controls for your AI
          </p>
        </div>
        <button disabled={userPlan === 'Free'} className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-324">
          <PlusIcon className="w-4 h-4" data-id="element-325" />
          Add Guardrail
        </button>
      </div>
      {/* Content placeholder */}
      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center" data-id="element-326">
        <ShieldCheckIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-327" />
        <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-328">
          Guardrail Configuration
        </h3>
        <p className="text-sm text-gray-600 max-w-md mx-auto" data-id="element-329">
          {userPlan === 'Free' ? 'This is a read-only demo. Upgrade to configure AI guardrails.' : 'Set up guardrails to ensure your AI outputs are safe, accurate, and on-brand.'}
        </p>
      </div>
    </div>;
}